import {Button, Card, Col, DatePicker, Form, Input, Row, Select, message} from 'antd'
import TextArea from 'antd/es/input/TextArea';
import { LotCodeOpsService } from 'libs/shared-services/production/src/lib/lot-code-ops.service';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { LotCreationReq } from '@gtpl/shared-models/production-management';
import { LotTypeEnum, PriorityEnum } from '@gtpl/shared-models/common-models';
import moment from 'moment';

const {Option} = Select;


export const LotCreation = () => {
    const [form] = Form.useForm()
    let history = useHistory()
    const lotService = new LotCodeOpsService()
    const userName = JSON.parse(localStorage.getItem('username'));

    const onReset = () => {
      form.resetFields()
    }

    const onFinish = (values:any) => {
      console.log(values,'values')
      const req = new LotCreationReq(values.lotType,values.remarks,userName,values.exFactoryDate != undefined ? moment(values.exFactoryDate).format('YYYY-MM-DD'): undefined,values.priority,moment(values.date).format('YYYY-MM-DD'))
      lotService.createLot(req).then(res => {
        if(res.status){
          AlertMessages.getSuccessMessage(res.internalMessage)
          history.push('/assign-material')
        }else{
          AlertMessages.getErrorMessage(res.internalMessage)
        }
      })
    }
    return(
        <Card title={<span style={{ color: 'white' }}>Lot Creation</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} 
          extra={<Button onClick={() => {history.push('/assign-material')}}>View</Button>}>
            <Form form={form} onFinish={onFinish} initialValues={{ date: moment() }}>
                <Row gutter={24}>
                  <Col  xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                    <Form.Item name='date' label='Date' rules={[{ required: true, message: 'Date is required' }]}>
                      <DatePicker style={{width:'100%'}}/>
                    </Form.Item>
                  </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='lotType' label='Lot Type' rules={[{required:true,message:'Lot Type is required'}]}>
                            <Select allowClear showSearch optionFilterProp='children' placeholder='Select Lot Type'>
                                {/* <Option key='Carding' value='Carding'>Carding</Option>
                                <Option key='Dressing' value='Dressing'>Dressing</Option>
                                <Option key='Blowing' value='Blowing'>Blowing</Option> */}
                                {
                                  Object.values(LotTypeEnum).filter(e => e !== LotTypeEnum.Bale).map(e => {
                                    return(
                                      <Option key={e} value={e}>{e}</Option>
                                    )
                                  })
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='remarks' label='Remarks' rules={[{required:true,message:'Remarks is required'}]}>
                            <TextArea placeholder='Enter Remarks'/>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='exFactoryDate' label='Ex-Factory Date'>
                            <DatePicker placeholder='Enter Ex-Factory Date' style={{width:'100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item name='priority' label='Priority'>
                            <Select allowClear showSearch optionFilterProp='children' placeholder='Select Priority'>
                              {
                                Object.values(PriorityEnum).map(e => {
                                  return(
                                    <Option key={e} value={e}>{e}</Option>
                                  )
                                })
                              }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                      <Form.Item>
                        <Button type='primary' htmlType='submit'>
                          Submit
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                      <Form.Item>
                        <Button onClick={onReset}>
                          Reset
                        </Button>
                      </Form.Item>
                    </Col>
                </Row>
            </Form>

        </Card>
    )
}

export default LotCreation